export class LinkedDocumentSavedInfo {
  public documentId: number;
  public createUserName: string;
}
